import {Deserializable} from './deserializable.model';

export class Address implements Deserializable {
 /* public brand?: 'BMW' | 'Audi' | 'Lamborghini' | 'Mercedes';
  public model?: string;
  public kW?: number;
  */

    Location?: number;
    Street?: string;
    City?: string;
    State?: string;
    PostCode?: string;
    Country?: string;
    Phone1?: string;
    Phone2?: string;
    Phone3?: string;
    Fax?: string;
    Email?: string;
    Website?: string;
    ContactName?: string;
    Salutation?: string;


  deserialize(input: any): this {
    return Object.assign(this, input);
  }
  
  getHp() {
   // return this.kW * 1.36;
  }
}